import { render, staticRenderFns } from "./allocation.vue?vue&type=template&id=fc49e3a0&scoped=true&"
import script from "./allocation.vue?vue&type=script&lang=js&"
export * from "./allocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc49e3a0",
  null
  
)

export default component.exports